export const restaurantInputs = [
  {
    id: 0,
    label: "Business Type",
    type: "radio",
    options: [
      { label: "Restaurant", value: "R" },
      { label: "Hotel", value: "H" },
      { label: "Retail", value: "RT" },
    ],
    name: "businessType",
  },
  {
    id: 1,
    label: "Entity Name",
    type: "text",
    placeholder: "Entity X",
  },
  {
    id: 2,
    label: "Entity Email",
    type: "email",
    placeholder: "restaurant@example.com",
  },
  {
    id: 3,
    label: "Phone Number",
    type: "tel",
    placeholder: "+1 234 567 890",
  },
  {
    id: 4,
    label: "Address",
    type: "text",
    placeholder: "123 Main Street",
  },
  {
    id: 5,
    label: "Country",
    type: "text",
    placeholder: "United States",
  },
  {
    id: 6,
    label: "GST Number",
    type: "text",
    placeholder: "GSTIN123456789",
  },
];


export const productInputs = [
  {
    id: 1,
    label: "Title",
    type: "text",
    placeholder: "Apple Macbook Pro",
  },
  {
    id: 2,
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: 3,
    label: "Category",
    type: "text",
    placeholder: "Computers",
  },
  {
    id: 4,
    label: "Price",
    type: "text",
    placeholder: "100",
  },
  {
    id: 5,
    label: "Stock",
    type: "text",
    placeholder: "in stock",
  },
];

export const userInputs = [
  {
    id: 1,
    label: "Full Name",
    type: "text",
    placeholder: "User's Name",
  },
  {
    id: 2,
    label: "Email",
    type: "text",
    placeholder: "Email",
  },
  {
    id: 3,
    label: "Phone No",
    type: "text",
    placeholder: "Phone Number",
  },
  {
    id: 4,
    label: "Age",
    type: "text",
    placeholder: "age",
  },

];
